import React from "react";
import axios from "axios";

// Direct function to subscribe email to Klaviyo
export const subscribeToKlaviyo = async (email) => {
  console.log(`Initiating opt-in process for ${email}...`);
  try {
    const listId = "XTBCJf";
    const companyId = "WCvH2F";
    const endpoint = "https://a.klaviyo.com/client/subscriptions";

    const urlWithQueryParams = `${endpoint}?company_id=${companyId}`;

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId,
            },
          },
        },
      },
    };

    const headers = {
      "Content-Type": "application/vnd.api+json",
      revision: "2024-10-15",
    };

    // Make the POST request
    await axios.post(urlWithQueryParams, payload, { headers });

    console.log(`Opt-in triggered successfully for ${email}`);
    return true;
  } catch (error) {
    console.error("Error triggering Klaviyo opt-in:", error);
    return false;
  }
};

const Klaviyo = ({ email }) => {
  const handleOptIn = React.useCallback(async () => {
    return await subscribeToKlaviyo(email);
  }, [email]);

  React.useEffect(() => {
    if (email) {
      handleOptIn();
    }
  }, [email, handleOptIn]);

  return <div></div>;
};

export default Klaviyo;
